import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

function ImageLightbox({ src, onClose }) {
  return (
    <AnimatePresence>
      {src && (
        <div className="modal" onClick={onClose} style={{ zIndex: 3000 }}>
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="modal-content"
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: '90vw', padding: '1rem', borderRadius: 'var(--border-radius-lg)' }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '0.5rem' }}>
              <button className="menu-toggle" onClick={onClose}><X /></button>
            </div>
            <img
              src={src}
              alt="Full Size"
              style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain', borderRadius: 'var(--border-radius-sm)' }}
            />
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

export default ImageLightbox;
